import  { useState, useEffect, useRef } from "react";
import { Table, Input, Spin, Modal } from "antd";
import { message } from "../../components/antdMessageBridge";
import CommonObj from "../../CommonObj";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import ManifestCreation1Icon from "../../assets/img/svg/xmanifestacceptanceicon3.svg";
import "./manifestcreation.css";
import { useAuth } from "../../auth/AuthContext";
import { Html5QrcodeScanType } from "html5-qrcode";
import html2pdf from "html2pdf.js";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService from "../../components/commonregex/regexService";
import { showManualEntryDisabledWarning } from "../../components/commonvalidation/manualEntryWarning";
import useFieldPermissions from "../../hooks/useFieldPermissions";

const MnifestCreation = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [form, setForm] = useState({
        bid: ""
    });
    const { roleUserId } = useAuth();
    const [sortedInfo, setSortedInfo] = useState({});
    const [searchFilters, setsearchFilters] = useState({});
    const { accessToken } = useAuthToken();
    const [cusdectext, setCusDecText] = useState("");
    const [scanimage, setScanImage] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [regexLoaded, setRegexLoaded] = useState(false);
    const { isReadOnly } = useFieldPermissions("manifestCreation");

    const isProcessingRef = useRef(false);
    const lastProcessedValueRef = useRef("");
    const timeoutRef = useRef(null);
    const lastRackKeyTimeRef = useRef(0);
    const clearRackTimerRef = useRef(null);

    useEffect(() => {
        return () => {
            clearTimeout(clearRackTimerRef.current);
        };
    }, []);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    useEffect(() => {
        if (cusdectext.trim() !== "" && cusdectext !== lastProcessedValueRef.current && !isProcessingRef.current) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                isProcessingRef.current = true;
                lastProcessedValueRef.current = cusdectext;

                cusSearch().finally(() => {
                    isProcessingRef.current = false;
                    setScanImage(false);
                    setActiveScanner(null);
                    setCusDecText("");
                });
            }, 300);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [cusdectext]);

    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);

    const onNewScanResult = (decodedText) => {
        if (decodedText === lastProcessedValueRef.current || isProcessingRef.current) {
            return;
        }

        setCusDecText(decodedText);
        setForm({ ...form, bid: decodedText });
        setScanImage(true);
    };

    const [activeScanner, setActiveScanner] = useState(null);

    const columns = [
        {
            title: "Rack Number",
            dataIndex: "rackNo",
            key: "rackNo",
            width: '50%',
        },
        {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
            width: '50%',
        }
    ];

    const getRowClassName = (record, index) => {
        return index % 2 === 0 ? "odd-row" : "even-row";
    };

    const onSelectChange1 = (newSelectedRowKeys, newSelectedRows) => {
        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedRows(newSelectedRows);
        let recy = 0,
            recv = 0;
        newSelectedRows?.map((items) => {
            if (items.status == 32) {
                recy++;
            }
            if (items.status == 33) {
                recv++;
            }
        });
        if (recy > 0 && recv > 0) {
            message.warning("Please select BIDs with the same status");
        }
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange1,
    };

    const handleTableChange = (newPagination, filters, sorter) => {
        const normalizeFilters = {};
        Object.keys(filters).forEach((key) => {
            if (filters[key] && filters[key].length > 0) {
                normalizeFilters[key] = filters[key][0];
            }
        });

        setsearchFilters(normalizeFilters);
        setSortedInfo(sorter);

        setPagination((prev) => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        }));

        fetchData({
            pagination: {
                current: newPagination.current,
                pageSize: newPagination.pageSize,
            },
            sorter,
            filters: normalizeFilters,
        });
    };

    const fetchData = async ({ pagination: pag, filters, sorter }) => {
        const bidValue = form?.bid?.trim() || "";
        if (bidValue.length > 0) {

            const payload = {
                RackNos: bidValue,
                UserId: 2
            };

            try {
                const myHeaders = {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp()
                };
                const response = await fetch(
                    CommonObj.Endpoints.GetBooksByRackNo,
                    {
                        method: "POST",
                        headers: myHeaders,
                        body: JSON.stringify(payload),
                    }
                );

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();
                if (data?.error === "No Ready to Recycle Details found") {
                    setData([]);
                    message.warning("The scanned Rack ID is not exist");
                } else {
                    setData(data);
                    const total = data[0]?.totalRows || 0;
                    setPagination((prev) => ({
                        ...prev,
                        total,
                    }));
                }
            } catch (err) {
                console.error(err);
            } 
        } else {
            setData([]);
            const total = 0;
            setPagination((prev) => ({
                ...prev,
                current: 1,
                total,
            }));
        }
    };

    if (loading) {
        return (
            <Spin size="large" style={{ margin: "20px auto" }} />
        );
    }

    const fetchBIDStatus = async (bid) => {
        const url = CommonObj.Endpoints.GetRackStatus;

        const formData = new FormData();
        formData.append("RackNos", bid);
        formData.append("UserId", roleUserId);

        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp()
                },
                body: formData,
            });
            const errorResponse = await response.json();

            if (response.ok) {
                if (errorResponse.rackNos) {
                    return errorResponse.rackNos;
                } else {
                    message.info(errorResponse.message);
                    return false;
                }
            } else {
                message.error(errorResponse?.error || "Failed to fetch Rack status")
                return false;
            }

        } catch (error) {
            return false;
        }
    };

    const cusSearch = async () => {
        let bidValue = form?.bid?.trim();
        let getExisit;

        if (bidValue.length === 0) {
            setData([]);
            setPagination(prev => ({ ...prev, current: 1, total: 0 }));
            return;
        }
        if (regexLoaded) {
            const validation = regexService.validateRack(bidValue);
            if (!validation.isValid) {
                setForm({ ...form, bid: "" });
                return message.error("Input format invalid: No matching pattern found.");
            }
        }
        
        setIsProcessing(true);

        try {
            const bidfetch = await fetchBIDStatus(bidValue);

            if (bidfetch) {
                bidValue = bidfetch;
            } else if (bidfetch === true) {
                return;
            } else if (!bidfetch) {
                setForm({ ...form, bid: "" });
                return;
            }

            const myHeaders = {
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp()
            };

            const formData = new FormData();
            formData.append("RackNos", bidValue);
            formData.append("UserId", roleUserId);

            const response = await fetch(CommonObj.Endpoints.GetBooksByRackNo, {
                method: "POST",
                headers: myHeaders,
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const apiResp = await response.json();

            if (apiResp?.error === "No Ready to Recycle Details found") {
                setData([]);
                setForm({ ...form, bid: "" });
                message.destroy();
                message.warning("The scanned Rack ID is not exist");
            } else {
                let DidManiFest = true;
                const ArrayRacrIds = data.map(item => item.rackNo);
                const racrIds = apiResp.map(item => item.rackNo).join(",");
                const girdExistData = data.filter(item => racrIds.includes(item.rackNo));
                getExisit = girdExistData.map(item => item.rackNo).join(",");
                const newItem = apiResp.filter(item => !ArrayRacrIds.includes(item.rackNo));

                setData(existingData => {
                    if (getExisit.length === 0) {
                        DidManiFest = false;
                        if (!DidManiFest) {
                            let masgRack = "Racks";
                            if (apiResp.length === 1) {
                                masgRack = "Rack";
                            }
                            message.success(`${apiResp.length} ${masgRack} added successfully!`);
                        }
                        return [...existingData, ...apiResp];
                    } else {
                        return [...existingData, ...newItem];
                    }
                });

                if (getExisit.length !== 0) {
                    message.error(`Rack no ${getExisit} is exisit already!`);
                }
                setForm({ ...form, bid: "" });
            }
        } catch (err) {
            console.log(err);
            setForm({ ...form, bid: "" });
        } finally {
            setIsProcessing(false);
        }
    };

    const handleDownload = async (key, mode) => {
        setIsDisabled(true);
        setTimeout(() => setIsDisabled(false), 3000);

        const isDownload = mode === "download";
        const label = isDownload ? "download" : "skip";

        if (key.length === 0) {
            return message.warning(`Please select at least one row to ${label}.`);
        }

        if (selectedRows.some(row => !row.rackNo)) {
            return message.error('Validation failed: Cannot download rows with an empty "Rack No."');
        }
        
        const submissionData = { rackNos: key.join(", "), userId: roleUserId };
        const fetchURL = isDownload ? CommonObj.Endpoints.DownloadManifest : CommonObj.Endpoints.SkipManifest;
        
        setLoading(true);

        try {
            const response = await fetch(fetchURL, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                    "X-CSRF-Token": encryptTimestamp()
                },
                body: JSON.stringify(submissionData),
            });

            if (!response.ok) {
                if (response.status === 404) message.error("File Not Found");
                throw new Error(`Response status: ${response.status}`);
            }

            setData(prev => prev.filter(item => !key.includes(item.rackNo)));

            if (isDownload) {
                await generatePdfFromHtml(await response.text());
                fetchData({ pagination, sorter: sortedInfo, filters: searchFilters });
            }

            message.success(`${isDownload ? "Downloading" : "Skipping"} data for ${selectedRows.length} item(s).`);
        } catch (error) {
            console.error("Error submitting form:", error.message);
        }finally{
            setLoading(false);
        }
    };

    const generatePdfFromHtml = async (htmlContent) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;

        const options = {
            margin: 0.5,
            filename: `manifest_${Date.now()}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: "in", format: "a4", orientation: "landscape" }
        };

        const pdfBlob = await html2pdf().set(options).from(tempDiv).outputPdf("blob");
        window.open(URL.createObjectURL(pdfBlob), "_blank");
        tempDiv.remove();
    };

    const handleSearchClick = () => {
        if (!isProcessingRef.current && form.bid.trim() !== "") {
            cusSearch();
        }
    };

    return (
        <>
            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => {
                    setActiveScanner(null);
                    isProcessingRef.current = false;
                }}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container no-padding-right">
                        <div className="book-page-title">
                            <span>
                                <img src={ManifestCreation1Icon} alt="Manifest Creation icon"></img>
                            </span>
                            <h2>Manifest Creation</h2>
                        </div>
                    </div>
                    <div className="book-page-form">
                        <div className="book-page-camera-button-container multiple">
                            <Input
                                placeholder=""
                                value={form.bid}
                                className={`${form.bid ? "has-id" : ""}`}
                                onChange={(e) => setForm({ ...form, bid: e.target.value })}
                                onKeyDown={(e) => {
                                    if (!isReadOnly("rack")) {
                                        return;
                                    }

                                    // Let native copy/paste behave normally (no custom clipboard handling).
                                    const isCopyOrPasteShortcut =
                                        (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
                                    if (isCopyOrPasteShortcut) {
                                        return;
                                    }

                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                        return;
                                    }

                                    const currentTime = Date.now();
                                    const timeDiff = currentTime - lastRackKeyTimeRef.current;
                                    lastRackKeyTimeRef.current = currentTime;

                                    // A physical scanner sends characters within a few milliseconds of each
                                    // other, so only block keystrokes that arrive slowly (manual typing).
                                    // The very first keystroke (field currently empty) is always let through
                                    // so a scan burst never loses its first character.
                                    const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
                                    if (!isSlowManualKeystroke) {
                                        return;
                                    }

                                    e.preventDefault();
                                    setForm((prev) => ({ ...prev, bid: '' }));

                                    clearTimeout(clearRackTimerRef.current);
                                    clearRackTimerRef.current = setTimeout(() => {
                                        showManualEntryDisabledWarning();
                                    }, 300);
                                }}
                                onPressEnter={cusSearch}
                                disabled={isProcessing}
                                id="manifest-rack-input-id"
                            />
                            {form.bid.length === 0 && (
                                <label htmlFor="manifest-rack-input-id">{isReadOnly("rack") ? "Scan " : "Enter / Scan "}Rack Number Using “<strong>Camera Icon</strong>”<span className="form-required">*</span></label>
                            )}
                            <button
                                type="button"
                                className="book-page-camera-button"
                                data-track="manifest-creation-open-rack-scanner"
                                onClick={() => setActiveScanner("Rack")}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34106 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                        fill="url(#paint0_linear_273_6917)"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                        fill="url(#paint1_linear_273_6917)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <button
                                type="button"
                                className="book-page-camera-button-input-2"
                                data-track="manifest-creation-search-rack"
                                onClick={handleSearchClick}
                                disabled={isProcessing}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                        fill="url(#paint0_linear_1900_8687)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_1900_8687"
                                            x1="20.6"
                                            y1="9.94475"
                                            x2="-0.0696504"
                                            y2="12.0919"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div className="table-container reducedbottom-padding-1">
                        <div className="rounded-table-wrapper">
                            <Table
                                rowSelection={rowSelection}
                                columns={columns}
                                loading={loading}
                                dataSource={data}
                                className="common-grid withScanner"
                                pagination={false}
                                rowKey={(record) => record.rackNo}
                                scroll={{ x: "max-content", y: "calc(100vh - 390px)" }}
                                rowClassName={getRowClassName}
                                onChange={handleTableChange}
                            />
                        </div>
                    </div>
                    <div className="book-page-footer-container">
                        <div className="book-page-action-container">
                            <div></div>
                            <div className="book-page-buttons-container">
                                <button className="download-button-outline-manifest" disabled={isDisabled} onClick={() => handleDownload(selectedRowKeys, "skip")}>
                                    <span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_4544_5522)">
                                                <path opacity="0.5" d="M1.66797 9.99984C1.66797 6.07147 1.66797 4.10728 2.88836 2.88689C4.10875 1.6665 6.07293 1.6665 10.0013 1.6665C13.9297 1.6665 15.8939 1.6665 17.1142 2.88689C18.3346 4.10728 18.3346 6.07147 18.3346 9.99984C18.3346 13.9282 18.3346 15.8924 17.1142 17.1128C15.8939 18.3332 13.9297 18.3332 10.0013 18.3332C6.07293 18.3332 4.10875 18.3332 2.88836 17.1128C1.66797 15.8924 1.66797 13.9282 1.66797 9.99984Z" stroke="url(#paint0_linear_4544_5522)" strokeWidth="1.375" />
                                                <path d="M7.08203 7.5L9.58203 10L7.08203 12.5" stroke="url(#paint1_linear_4544_5522)" strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M10.418 7.5L12.918 10L10.418 12.5" stroke="url(#paint2_linear_4544_5522)" strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <defs>
                                                <linearGradient id="paint0_linear_4544_5522" x1="18.8346" y1="9.9538" x2="1.60993" y2="11.7431" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="var(--color-1)" />
                                                    <stop offset="1" stopColor="var(--color-2)" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_4544_5522" x1="9.65703" y1="9.98619" x2="7.05247" y2="10.1215" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="var(--color-1)" />
                                                    <stop offset="1" stopColor="var(--color-2)" />
                                                </linearGradient>
                                                <linearGradient id="paint2_linear_4544_5522" x1="12.993" y1="9.98619" x2="10.3884" y2="10.1215" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="var(--color-1)" />
                                                    <stop offset="1" stopColor="var(--color-2)" />
                                                </linearGradient>
                                                <clipPath id="clip0_4544_5522">
                                                    <rect width="20" height="20" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                    <span>Skip Manifest</span>
                                </button>
                                <button className="download-button-gradient-manifest" disabled={isDisabled} onClick={() => handleDownload(selectedRowKeys, "download")}><span><svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_319_32002)">
                                        <path
                                            d="M4.99999 14.9856C3.70545 14.9466 2.93331 14.8022 2.39889 14.2678C1.66666 13.5355 1.66666 12.357 1.66666 10C1.66666 7.64298 1.66666 6.46447 2.39889 5.73223C3.13112 5 4.30963 5 6.66666 5H13.3333C15.6903 5 16.8689 5 17.6011 5.73223C18.3333 6.46447 18.3333 7.64298 18.3333 10C18.3333 12.357 18.3333 13.5355 17.6011 14.2678C17.0667 14.8022 16.2945 14.9466 15 14.9856"
                                            stroke="white"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M7.5 8.33331H5"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M15.8333 11.6667L4.16668 11.6667"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M15 11.6667V13.3334C15 15.6904 15 16.8689 14.2678 17.6011C13.5355 18.3334 12.357 18.3334 10 18.3334C7.64298 18.3334 6.46447 18.3334 5.73223 17.6011C5 16.8689 5 15.6904 5 13.3334V11.6667"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M14.9856 5.00002C14.9466 3.70548 14.8022 2.93334 14.2678 2.39892C13.5355 1.66669 12.357 1.66669 10 1.66669C7.64298 1.66669 6.46446 1.66669 5.73223 2.39892C5.19781 2.93334 5.05344 3.70548 5.01443 5.00002"
                                            stroke="white"
                                            strokeWidth="1.5"
                                        />
                                        <circle
                                            opacity="0.5"
                                            cx="14.1667"
                                            cy="8.33333"
                                            r="0.833333"
                                            fill="white"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M12.5 13.75H7.5"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M10.8333 15.8333H7.50001"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_319_32002">
                                            <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></span>Download Manifest</button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default MnifestCreation;
